import { PropsWithChildren, memo } from 'react';

interface Props {
    className?: string;
    gapX?: 'sm' | 'md' | 'lg';
    gapY?: 'sm' | 'md' | 'lg';
}

const Grid: React.FC<PropsWithChildren<Props>> = ({
    children,
    className = '',
    gapX = 'sm',
    gapY = 'sm',
}) => {

    let gapXClass = ''
    if ('sm' === gapX) { gapXClass = 'lg:gap-x-4' }
    if ('md' === gapX) { gapXClass = 'lg:gap-x-12' }
    if ('lg' === gapX) { gapXClass = 'lg:gap-x-20' }

    let gapYClass = ''
    if ('sm' === gapY) { gapYClass = 'gap-y-4' }
    if ('md' === gapY) { gapYClass = 'gap-y-12' }
    if ('lg' === gapY) { gapYClass = 'gap-y-20' }

    return (
        <div className={`grid grid-cols-1 lg:grid-cols-12 mx-auto ${gapXClass} ${gapYClass} ${className}`}>
            {children}
        </div>
    )
}

export default memo(Grid);